import React, { useEffect } from "react";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import { withStyles } from "tss-react/mui";
import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";
import DateFilter from "./DateFilter";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";
import { addDays, format, parse } from "date-fns";

function OrderDateFilter(props) {
  useEffect(() => {
    if (!props.vestiging_id && !props["vestiging.venue_id"]) {
      props.setFilter("order:fromAangemaakt", null);
      props.setFilter("order:toAangemaakt", null);
    }
  }, [props["vestiging.venue_id"], props["vestiging_id"]]);
  return (
    <GridContainer>
      <GridItem md={1} xs={12}>
        <div style={{ paddingTop: "5px" }}>
          <TranslationWrapper tKey={"From"} />
        </div>
      </GridItem>
      <GridItem md={2} xs={12}>
        <DateFilter
          field={"aangemaakt"}
          fieldKey={"order:fromAangemaakt"}
          operator={">="}
          parseValue={(value) => {
            if (!value) return value;
            return format(parse(value, "yyyy-MM-dd", new Date()), "yyyy-MM-dd HH:mm:ss");
          }}
        />
      </GridItem>
      <GridItem md={1} xs={12}>
        <div style={{ paddingTop: "5px" }}>
          <TranslationWrapper tKey={"To"} />
        </div>
      </GridItem>
      <GridItem md={2} xs={12}>
        <DateFilter
          field={"aangemaakt"}
          fieldKey={"order:toAangemaakt"}
          operator={"<"}
          parseValue={(value) => {
            if (!value) return value;
            return format(addDays(parse(value, "yyyy-MM-dd", new Date()), 1), "yyyy-MM-dd HH:mm:ss");
          }}
        />
      </GridItem>
    </GridContainer>
  );
}

const mapStateToProps = (state, props) => ({
  ["vestiging_id"]: state.filtersV2["vestiging_id"],
  ["vestiging.venue_id"]: state.filtersV2["vestiging.venue_id"],
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(OrderDateFilter, productenStyle));
